"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _tkComponentIcons = require("@xo-union/tk-component-icons");
var _SubNavIconLinkModule = _interopRequireDefault(require("./SubNavIconLink.module.css"));
const renderIcon = (iconName, size, hasBadge, badgeValue) => {
  const shouldRenderBadge = hasBadge || !!badgeValue && badgeValue > 0;
  const badgeContent = !!badgeValue && badgeValue > 0 ? badgeValue : undefined;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "SubNavIconLink__icon"
  }, shouldRenderBadge && /*#__PURE__*/_react.default.createElement("div", {
    className: _SubNavIconLinkModule.default.subNavIconLink__badge,
    "data-testid": "SubNavIconLink__icon__badge"
  }, badgeContent), /*#__PURE__*/_react.default.createElement(_tkComponentIcons.IconButton, {
    name: iconName,
    size: size,
    className: _SubNavIconLinkModule.default.subNavIconLink__icon,
    "aria-label": iconName
  }));
};
const SubNavIconLink = _ref => {
  let {
    iconName,
    text,
    size,
    href,
    ariaLabel,
    hasBadge,
    badgeValue
  } = _ref;
  const shouldRenderText = !!text;
  const classes = _SubNavIconLinkModule.default.subNavIconLink__text__experiment;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: _SubNavIconLinkModule.default.subNavIconLink__container,
    href: href,
    "aria-label": ariaLabel,
    "data-testid": "SubNavIconLink"
  }, !shouldRenderText && renderIcon(iconName, size, hasBadge, badgeValue), shouldRenderText && /*#__PURE__*/_react.default.createElement("span", {
    className: classes,
    "data-testid": "SubNavIconLink__text"
  }, text));
};
var _default = exports.default = SubNavIconLink;